import { on, remove } from '../utils/dom'
function getScrollParent(ele) {
  let parent = ele.parentNode
  if (!parent) {
    return ele
  }
  if (parent === window.document) {
    if (window.document.body.scrollTop || window.document.body.scrollLeft) {
      return window.document.body
    } else {
      return window.document.documentElement
    }
  }
  const styles = window.getComputedStyle(parent, null)
  if (
    ['auto', 'scroll'].indexOf(styles['overflow']) > -1 ||
    ['auto', 'scroll'].indexOf(styles['overflow-x']) > -1 ||
    ['auto', 'scroll'].indexOf(styles['overflow-y']) > -1
  ) {
    return parent
  }
  return getScrollParent(parent)
}
export default {
  prop: ['rootElement'],
  data() {
    return {
      parentElement: '',
      status: 'bottom'
    }
  },
  methods: {
    scrollEvent() {
      const self = this.$el.getBoundingClientRect()
      const parent = this.parentElement.getBoundingClientRect()
      // if (self.bottom > parent.bottom) {
      //   this.status = 'poppertop'
      // }
      // if (self.top < parent.top) {
      //   this.status = 'popperbottom'
      // }
      if (self.right < parent.right) {
        this.status = 'popperright'
      }
      if (self.right >= parent.right) {
        this.status = 'popperleft'
      }
      // if (self.top > parent.top && self.bottom < parent.bottom) {
      //   this.status = 'bottom'
      // }
    },
    addEvent(ele) {
      // on(ele, 'scroll', this.scrollEvent)
      on(window, 'resize', this.scrollEvent)
    },
    removeEvent(ele) {
      // remove(ele, 'scroll', this.scrollEvent)
      remove(window, 'resize', this.scrollEvent)
    }
  },
  watch: {
    status() {
      this.scrollEvent()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.parentElement = this.rootElement || getScrollParent(this.$el)
      // this.addEvent(this.parentElement)
      this.scrollEvent()
      console.log(this.parentElement)
    })
  },
  destroy() {
    this.removeEvent(this.parentElement)
  }
}



// WEBPACK FOOTER //
// ./src/ui/src/mixins/popper.js